import React, { useContext } from "react";
import { cn } from "../../lib/helpers";
import { SiteContext } from "../global/site-context";
import { pageDocPath } from "../../../helpers";

const LEFT = { label: `Common Room`, path: "/pricing/" };
const RIGHT = { label: "Zoom", path: "/pricing/zra/" };

const Side = ({ option, isHighlighted, highlightClass }) => (
  <a
    href={option.path}
    className={cn(
      "flex-1 text-center rounded-full px-6 py-2 font-medium transition-colors duration-200 whitespace-nowrap",
      isHighlighted
        ? cn(highlightClass, "hover:opacity-80")
        : "text-black hover:text-link"
    )}
  >
    {option.label}
  </a>
);

export const ToggleCta = () => {
  const site = useContext(SiteContext);
  const currentPath = pageDocPath(site?.doc);

  const isLeftActive = LEFT.path === currentPath;
  const isRightActive = RIGHT.path === currentPath;

  return (
    <div className="flex justify-center">
      <div className="inline-flex bg-white rounded-full p-1.5 text-black">
        <Side
          option={LEFT}
          isHighlighted={isLeftActive}
          highlightClass="bg-green-emerald text-white"
        />
        <Side
          option={RIGHT}
          isHighlighted={isRightActive}
          highlightClass="bg-link text-white"
        />
      </div>
    </div>
  );
};
